// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 08-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD PRODUCT DETAILS START *********************** */
export const productDetailsAdd = (addData: any) => {
	const data = {
		AddProductDetailsToken: addData,
	};
	const url = `${API_URL}addProductDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD PRODUCT DETAILS END *********************** */

/** ***************** UPDATE PRODUCT DETAILS START *********************** */
export const productDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateProductDetailsToken: updateData,
	};
	const url = `${API_URL}updateProductDetails`;
	return makeApiCall(url, data);
};
/** ***************** END PRODUCT DETAILS START *********************** */

/** ***************** GET PRODUCT LIST START *********************** */
export const productListGet = (listData: any) => {
	const data = {
		GetProductListToken: listData,
	};
	const url = `${API_URL}getProductList`;
	return makeApiCall(url, data);
};
/** ***************** GET PRODUCT LIST END *********************** */

/** ***************** FETCH PRODUCT DETAILS START *********************** */
export const productDetailsFetch = (fetchData: any) => {
	const data = {
		FetchProductDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchProductDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PRODUCT DETAILS END *********************** */

/** ***************** FETCH CUSTOM PRODUCT DETAILS START *********************** */
export const customProductDetailsFetch = (fetchData: any) => {
	const data = {
		GetCustomProductListToken: fetchData,
	};
	const url = `${API_URL}getCustomProductListWithToken`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CUSTOM PRODUCT DETAILS END *********************** */

/** ***************** DELETE PRODUCT DETAILS START *********************** */
export const productDetailsDelete = (deleteData: any) => {
	const data = {
		PublishProductDetailsToken: deleteData,
	};
	const url = `${API_URL}updateProductPublishStatusWithToken`;
	return makeApiCall(url, data);
};
/** ***************** DELETE PRODUCT DETAILS END *********************** */

/** ***************** GET MATSER ACCOUNT LIST START ************************/
export const getMasterAccountList = (listData: any) => {
	const data = {
		GetMasterAccountListData: listData,
	};
	const url = `${API_URL}getMasterAccountList`;
	return makeApiCall(url, data);
};
/** ***************** GET MATSER ACCOUNT LIST END ************************/

/** *********************  START GET ALL INSTRUMENT LIST  ******************** */
export const getAllInstrumentList = (listData: any) => {
	const data = {
		GetAllInstrumentListData: listData,
	};
	const url = `${API_URL}getAllInstrumentList`;
	return makeApiCall(url, data);
};
/** *********************  END GET ALL INSTRUMENT LIST  ******************** */

/** *********************  START FETCH FILTER PRODUCT LIST  ******************** */
export const filterProductListGet = (listData: any) => {
	const data = {
		GetFilterProductListToken: listData,
	};
	const url = `${API_URL}getFilterProductListWithToken`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH FILTER PRODUCT LIST  ******************** */

/** *********************  GET PRODUCT DETAILS LIST START ******************** */
export const productDetailsListGet = (listData: any) => {
	const data = {
		getProductDetailsToken: listData,
	};
	const url = `${API_URL}GetProductDetailsWithToken`;
	return makeApiCall(url, data);
};
/** *********************  GET PRODUCT DETAILS LIST END ******************** */
